import React from 'react';
import Layout from '../Layout';

const IconButtonView = (props) => (
  <Layout {...props} type="IconButtonView"/>
)
export default IconButtonView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/IconButtonView.js